import { OnInit } from '@angular/core';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { UserService } from '../../shared/user/user.service';
import { first } from 'rxjs/operators';
var FavoriteEventsListComponent = /** @class */ (function () {
    function FavoriteEventsListComponent(_aviationEventsService, _userService) {
        this._aviationEventsService = _aviationEventsService;
        this._userService = _userService;
        this.userInfo = null;
    }
    FavoriteEventsListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._userService.userInfo.pipe(first(function (v) { return v !== null; })).subscribe(function (e) { return _this._onUserInfoUpdate(e); });
    };
    FavoriteEventsListComponent.prototype._onUserInfoUpdate = function (e) {
        this.userInfo = e;
        var idList = $.map(this.userInfo.favoriteEvents, function (a) {
            return a.eventId;
        }).join();
        if (idList) {
            this.favoritesPromise = new StatefulPromise(this._aviationEventsService.getFavoriteEvents(idList));
        }
        else {
            this.favoritesPromise = null;
        }
    };
    Object.defineProperty(FavoriteEventsListComponent.prototype, "_favorites", {
        get: function () {
            if (!this.favoritesPromise || this.favoritesPromise.state !== PromiseState.Fulfilled) {
                return null;
            }
            return this.favoritesPromise.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FavoriteEventsListComponent.prototype, "favorites", {
        get: function () {
            return this._favorites;
        },
        enumerable: true,
        configurable: true
    });
    return FavoriteEventsListComponent;
}());
export { FavoriteEventsListComponent };
